export const HERO_COMPONENTS = ["HeroClassic", "InfoDots", "HeroSmallWithCard", "HeroSmallJustImage", "HeroSliderFullHeight" , "FullWidthVideoTextComponent"];
export const NO_SPACING_COMPONENTS = ["StandaloneContactFormFloating",];
export const COMPONENTS_WITH_CUSTOM_NAVSPACE = ["PressListing", "InspireListing"];